import axiosInstance from '../helpers/axiosInstance';

export const getreportPurchaseApi = async (pageNo, filterData = {}) => {
    const fn = filterData.firstName ?? "";
    const userId = filterData.userId ?? "";
    const fromDate = filterData.fromDate ?? "";
    const toDate = filterData.toDate ?? "";

    const query = `firstName=${fn}&userId=${userId}&fromDate=${fromDate}&toDate=${toDate}&page=${pageNo}`;
    const url = Object.keys(filterData).length > 0
        ? `staff/reports/purchaseOrder?${query}`
        : `staff/reports/purchaseOrder?page=${pageNo}`;

    const response = await axiosInstance.get(url);
    return response.data;
};

export const getreportPurchaseDownloadApi = async (pageNo, filterData = {}) => {
    const fn = filterData.firstName ?? "";
    const userId = filterData.userId ?? "";
    const fromDate = filterData.fromDate ?? "";
    const toDate = filterData.toDate ?? "";

    const query = `firstName=${fn}&userId=${userId}&fromDate=${fromDate}&toDate=${toDate}&page=${pageNo}`;
    const url = Object.keys(filterData).length > 0
        ? `staff/reports/sendPurchaseOrder/csv?${query}`
        : `staff/reports/sendPurchaseOrder/csv?page=${pageNo}`;

    const response = await axiosInstance.get(url, { responseType: 'text' });
    return response.data;
};
